import Reveal from "./Reveal";
import Eyebrow from "./Eyebrow";

const SERVICES = [
    {
        n: "01",
        title: "Çekim",
        desc: "İşletmenizde, markanıza uygun doğal fotoğraf ve video çekimleri.",
    },
    {
        n: "02",
        title: "Kurgu",
        desc: "Çekimlerin sade, hızlı ve izlenebilir şekilde düzenlenmesi.",
    },
    {
        n: "03",
        title: "İçerik Yönetimi",
        desc: "Aylık içerik planı, tasarım ve paylaşım takvimi.",
    },
    {
        n: "04",
        title: "Reklam Yönetimi",
        desc: "Doğru kitleye, kontrollü bütçeyle reklam yönetimi.",
    },
];

export default function Services() {
    return (
        <section id="hizmetler" data-testid="services-section" className="scroll-mt-24 py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10">
                <div className="grid gap-8 md:grid-cols-2 md:gap-12">
                    <Reveal>
                        <Eyebrow>Hizmetler</Eyebrow>
                        <h2 className="mt-5 font-display text-4xl leading-tight text-cream sm:text-5xl lg:text-6xl">
                            İçerik üretmekten fazlası.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1} className="md:pt-14">
                        <p className="max-w-md text-base leading-relaxed text-fog md:text-lg">
                            Markanızın sosyal medyada nasıl göründüğünü, nasıl
                            konuştuğunu ve nasıl büyüdüğünü birlikte yönetiyoruz.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 md:mt-20">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.06}>
                            <div
                                data-testid={`service-item-${s.n}`}
                                className={`group flex flex-col gap-3 border-t border-cream/10 py-8 transition-colors md:flex-row md:items-baseline md:gap-10 md:py-12 ${
                                    i === SERVICES.length - 1 ? "border-b" : ""
                                }`}
                            >
                                <span className="text-sm text-dim">{s.n}</span>
                                <h3 className="font-display text-3xl text-cream transition-transform duration-500 group-hover:translate-x-2 md:text-5xl">
                                    {s.title}
                                </h3>
                                <p className="max-w-sm text-sm leading-relaxed text-fog md:ml-auto md:text-base">
                                    {s.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
